import { addFilters, getPlaceDetails, selectPlaceFilters } from 'containers/MapDetails/placeSlice'
import { findAvailableWarehouseId } from './hooks/usePlaceFilters'
import { getMapData } from 'containers/Playground/playgroundSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import UnavailablePopupContext from './UnavailablePopupContext'
import UnavailablePopup from './UnavailablePopup'
import Loading from 'components/Loading'

const PlaceMapData = ({ children, showMap }) => {
  const filters = useReduxSelector(selectPlaceFilters)
  const [isLoading, setLoading] = useState(true)
  const [isUnavailable, setUnavailable] = useState(false)
  const openUnavailablePopup = useCallback(() => setUnavailable(true), [])
  const closeUnavailablePopup = useCallback(() => setUnavailable(false), [])
  const { placeId, id } = usePlaceMapParams()
  const currentFilters = useRef(filters)
  currentFilters.current = filters
  const currentObjectId = useRef(id)
  currentObjectId.current = id

  const dispatch = useReduxDispatch()
  const { replace, push } = useHistory()

  useEffect(() => {
    if (window.location.search) {
      const query = new URLSearchParams(window.location.search)
      const warehouseTypeId = query.get('warehouseTypeId')
      const hash = query.get('hash')
      if ((warehouseTypeId && warehouseTypeId !== 'undefined') || (hash && hash !== 'undefined')) {
        const attributes = { ...currentFilters.current.attributes }
        if (warehouseTypeId) attributes.warehouseTypeId = warehouseTypeId
        if (hash) attributes.hash = hash
        dispatch(addFilters({
          filters: {
            ...currentFilters.current,
            status: { isAvailableForRent: true },
            attributes
          }
        }))
        replace(window.location.pathname)
      }
    } else {
      dispatch(addFilters({
        filters: {
          ...currentFilters.current,
          status: { isAvailableForRent: true }
        }
      }))
    }

    return () => {
      const { status, ...filters } = currentFilters.current
      dispatch(addFilters({ filters }))
    }
  }, [dispatch, replace])

  useEffect(() => {
    dispatch(getPlaceDetails(placeId)).then(({ payload }) => {
      const displayOptions = payload?.places?.[0]?.displayOptions
      if (displayOptions?.listAllWarehouses || displayOptions?.showList || displayOptions?.showMap) {
        setLoading(false)
        showMap(!!displayOptions?.showMap)
        dispatch(getMapData(placeId)).then(res => {
          if (res.meta.requestStatus === 'fulfilled' && res.payload.maps?.[0]?.objects?.warehouses) {
            const warehouseId = findAvailableWarehouseId(res.payload.maps?.[0]?.objects?.warehouses)
            if (warehouseId) {
              const action = currentObjectId.current ? replace : push
              action(`/placemap/${placeId}/${warehouseId}`)
            } else {
              openUnavailablePopup()
            }
          }
        })
      } else {
        replace(`/mapdetails/${placeId}`)
      }
    })
  }, [dispatch, openUnavailablePopup, placeId, push, replace, showMap])

  return isLoading
    ? <Loading />
    : <UnavailablePopupContext.Provider value={openUnavailablePopup}>
      {children}
      <UnavailablePopup
        isOpen={isUnavailable}
        close={closeUnavailablePopup}
      />
    </UnavailablePopupContext.Provider>
}

export default PlaceMapData